import { defaultAxiosInstance } from '../config/axiosConfig';

/**
 * Per-user connection keys for Platform MCP ("Quadroid") — what a user pastes
 * into an AI app (Claude, ChatGPT, Cursor…) to manage their agents from there.
 * The page data lives in platformMcpService.
 *
 * Listing and revoking work even without the `platform_mcp` permission, so a
 * user who lost access can still clean up. Creating needs it (403).
 *
 * All three calls use the user's normal x-api-key. An MCP key is refused here
 * (401), so an MCP key can never create or revoke keys.
 *
 * Key shape: { id, name, last4, created_at, last_used_at, expires_at,
 *              revoked_at, active }
 */
class McpKeysService {
  /**
   * POST /user/mcp-keys — `name` optional, up to 200 characters.
   * → 201 key shape + `key`, `connector_url` and `connect` (per-app
   *   instructions), returned only here and never again. `connect` is null
   *   until the platform admin sets up the server.
   * 400 with `error` once the user has 10 active keys.
   */
  async createKey(name) {
    const body = name ? { name } : {};
    const response = await defaultAxiosInstance.post('/user/mcp-keys', body);
    return response.data;
  }

  /** GET /user/mcp-keys → { keys: [...], total }, newest first, revoked included. */
  async listKeys() {
    const response = await defaultAxiosInstance.get('/user/mcp-keys');
    return response.data;
  }

  /**
   * DELETE /user/mcp-keys/{id} → the row with `revoked_at` set. Connectors using
   * the key stop working immediately. Revoking twice is harmless; another
   * user's or a missing key is a 404.
   */
  async revokeKey(id) {
    const response = await defaultAxiosInstance.delete(`/user/mcp-keys/${id}`);
    return response.data;
  }
}

const mcpKeysService = new McpKeysService();
export default mcpKeysService;
